import React, { useMemo } from "react";
import Candcard from "../molecules/Candcard";

const pick = (obj, ...keys) => {
  for (const k of keys) {
    const v = obj?.[k];
    if (v !== undefined && v !== null) return v;
  }
  return "";
};

const pickKey = (job, idx) =>
  String(job?.jobId ?? job?.id ?? job?._id ?? job?.referenceNumber ?? idx);

const Pagination = ({ page, totalPages, onPageChange }) => {
  const prevDisabled = page <= 1;
  const nextDisabled = page >= totalPages;

  return (
    <div className="flex items-center justify-between md:justify-start gap-3 py-4 w-full max-w-full md:max-w-[800px] flex-wrap">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={prevDisabled}
        className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
          prevDisabled
            ? "text-gray-400 border-gray-200 cursor-not-allowed"
            : "text-gray-700 border-gray-300 hover:border-[#FFCC00] hover:text-[#FFCC00]"
        }`}
      >
        ← Previous
      </button>
      <span className="text-gray-600 text-sm">
        Page <span className="font-semibold">{page}</span> of{" "}
        <span className="font-semibold">{totalPages}</span>
      </span>
      <button
        onClick={() => onPageChange(page + 1)}
        disabled={nextDisabled}
        className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
          nextDisabled
            ? "text-gray-400 border-gray-200 cursor-not-allowed"
            : "text-gray-700 border-gray-300 hover:border-[#FFCC00] hover:text-[#FFCC00]"
        }`}
      >
        Next →
      </button>
    </div>
  );
};

const CandidateTemp = ({
  jobs = [],
  searchValue = "",
  loading = false,
  page = 1,
  pageSize = 10,
  onPageChange = () => {},
}) => {
  const filtered = useMemo(() => {
    const q = (searchValue || "").toLowerCase().trim();
    if (!q) return jobs;

    return jobs.filter((job) => {
      const jid   = (pick(job, "jobId", "id", "_id") || "").toString().toLowerCase();
      const title = (pick(job, "positionTitle", "title", "name") || "").toLowerCase();
      const ref   = (pick(job, "referenceNumber", "requestId", "refNo") || "").toLowerCase();
      const reg   = (pick(job, "region", "city", "location") || "").toLowerCase();
      return jid.includes(q) || title.includes(q) || ref.includes(q) || reg.includes(q);
    });
  }, [jobs, searchValue]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const start = (page - 1) * pageSize;
  const pageItems = filtered.slice(start, start + pageSize);

  return (
    <div className="space-y-4">
      <div
        id="admin-jobs-scroll-area"
        className="space-y-4 max-h-[70vh] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
      >
        {loading ? (
          <div className="p-4 bg-white rounded shadow text-gray-600">Loading jobs…</div>
        ) : pageItems.length === 0 ? (
          <div className="p-4 bg-white rounded shadow text-gray-600">No jobs found.</div>
        ) : (
          pageItems.map((job, idx) => (
            <div key={pickKey(job, idx)} className="w-full max-w-full md:max-w-[800px]">
              <Candcard job={job} />
            </div>
          ))
        )}
      </div>

      {!loading && filtered.length > 0 && (
        <Pagination page={page} totalPages={totalPages} onPageChange={onPageChange} />
      )}
    </div>
  );
};

export default CandidateTemp;
